export const EstadoNotificacion = Object.freeze({
    PENDIENTE: "PENDIENTE",
    ENVIADO: "ENVIADO",
    ERROR: "ERROR",
    NO_APLICA:"NO_APLICA"
});
